import { render } from "./calendario.vue?vue&type=template&id=09aed85b&scoped=true"
import script from "./calendario.vue?vue&type=script&lang=js"
export * from "./calendario.vue?vue&type=script&lang=js"

import "./calendario.vue?vue&type=style&index=0&id=09aed85b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aed85b"]])

export default __exports__